import { render, staticRenderFns } from "./CompleteRegister.vue?vue&type=template&id=657fcba9&scoped=true&"
import script from "./CompleteRegister.vue?vue&type=script&lang=js&"
export * from "./CompleteRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegister.vue?vue&type=style&index=0&id=657fcba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657fcba9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VForm,VStepper,VStepperContent,VStepperItems})
